import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    api.post("/auth/session", { session_id: sid })
      .then((r) => {
        setUser(r.data);
        window.history.replaceState(null, "", "/app");
        navigate("/app", { replace: true });
      })
      .catch((e) => {
        const d = e?.response?.data?.detail;
        if (d?.code === "not_registered") {
          window.history.replaceState(null, "", "/daftar");
          navigate("/daftar", { replace: true, state: d });
          return;
        }
        toast.error(typeof d === "string" ? d : "Login gagal, silakan coba lagi");
        navigate("/", { replace: true });
      });
  }, [location.hash, navigate, setUser]);

  return null;
}
